import { render, staticRenderFns } from "./StampedList.vue?vue&type=template&id=0c57aa16&scoped=true&"
import script from "./StampedList.vue?vue&type=script&lang=js&"
export * from "./StampedList.vue?vue&type=script&lang=js&"
import style0 from "./StampedList.vue?vue&type=style&index=0&id=0c57aa16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57aa16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c57aa16')) {
      api.createRecord('0c57aa16', component.options)
    } else {
      api.reload('0c57aa16', component.options)
    }
    module.hot.accept("./StampedList.vue?vue&type=template&id=0c57aa16&scoped=true&", function () {
      api.rerender('0c57aa16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/StampedList.vue"
export default component.exports